export default __webpack_public_path__ + "static/media/14.d921cfc0.png";